"use client";
import { FC } from "react";
import styles from "./ev-savings-badge.module.scss";
import Iframe from "@/ui/common-components/iframe";
import useCheckLectrum from "../useCheckLectrum";

type Props = {
  vin: string;
  domain: string;
  badgeId: string;
};

const EVSavingsBadgeClient: FC<Props> = ({ vin, domain, badgeId }) => {
  const visible = useCheckLectrum({ vin, domain });

  if (!visible) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <Iframe url={`https://ev-badge.lectrium.com/${badgeId}?vin=${vin}`} />
    </div>
  );
};

export default EVSavingsBadgeClient;
